/**
 * iOS-aware blob download helper.
 *
 * iOS Safari ignores the <a download> attribute on blob URLs, so the file
 * never lands in a "Downloads" folder. Instead we open the blob in a new tab,
 * which lets the user tap the Share button and Save to Files / Books / Print.
 *
 * On non-iOS devices we fall back to the standard programmatic-anchor click.
 */
export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const downloadBlob = (blob, filename, type = 'application/pdf') => {
  const file = blob instanceof Blob ? blob : new Blob([blob], { type });
  const url = URL.createObjectURL(file);

  if (isIOS()) {
    const opened = window.open(url, '_blank');
    if (!opened) window.location.href = url;
  } else {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  setTimeout(() => URL.revokeObjectURL(url), 10000);
};
